import { cloneDeep } from "lodash";

import {
    ReportItemsState,
    ReportTabType,
} from "types/Reports";
import { fetchDevices } from "utils/gatewayFunctions";
import { initialReportItemsState } from "./reportInitData";
import { retrieveRoomsAndMeters, retrieveSensors } from "./reportRetrieve";
import { getShowTabs } from "./report";

export const initializeReportItemsState = async (currentOrgId: string) => {
    const devices = await fetchDevices();

    const {
        rooms,
        energyMeters,
        flowMeters,
    } = await retrieveRoomsAndMeters(devices, currentOrgId);
    const {
        waterLeakageSensors,
        temperatureSensors,
        humiditySensors,
        co2Sensors,
        pressureSensors,
        tvocSensors,
        pm1Sensors,
        pm25Sensors,
        pm10Sensors,
    } = retrieveSensors(devices);

    const initItems = cloneDeep(initialReportItemsState);

    const types = Object.keys(initItems) as (keyof ReportItemsState)[];

    for (const type of types) {
        switch(type) {
            case 'room':
                initItems[type].all = rooms;
                break;
            case 'energy':
                initItems[type].all = energyMeters;
                break;
            case 'water':
                initItems[type].all = flowMeters;
                break;
            case 'waterLeakage':
                initItems[type].all = waterLeakageSensors;
                break;
            case 'temperature':
                initItems[type].all = temperatureSensors;
                break;
            case 'humidity':
                initItems[type].all = humiditySensors;
                break;
            case 'co2':
                initItems[type].all = co2Sensors;
                break;
            case 'pressure':
                initItems[type].all = pressureSensors;
                break;
            case 'tvoc':
                initItems[type].all = tvocSensors;
                break;
            case 'pm1':
                initItems[type].all = pm1Sensors;
                break;
            case 'pm2.5':
                initItems[type].all = pm25Sensors;
                break;
            case 'pm10':
                initItems[type].all = pm10Sensors;
                break;
            default:
                break;
        }
    }

    return initItems;
};

export const initializeReportPage = async (
    currentOrgId: string,
    setState: {
        setResourcesLoading: React.Dispatch<React.SetStateAction<boolean>>,
        setItems: React.Dispatch<React.SetStateAction<ReportItemsState>>,
        setShowTabs: React.Dispatch<React.SetStateAction<ReportTabType[]>>,
    },
) => {
    const newItems = await initializeReportItemsState(currentOrgId);
    const newShowTabs = getShowTabs(newItems, true);

    // set the filter section (no items selected/applied initially)
    setState.setItems(newItems);
    setState.setShowTabs(newShowTabs);

    // turn off the resource loading icon
    setState.setResourcesLoading(false);
};
